/*----------------------------------------------------------
jQuery Click Event Functions
------------------------------------------------------------*/

//Show More/Less jQuery
$(document).on('click', '.show-button a, .hide-button a', function(){
  $(this).parents('ol').find('.hidden-filter').slideToggle();
  if($(this).parent().hasClass('show-button')){
    $(this).parent().removeClass('show-button');
    $(this).parent().addClass('hide-button');
    $(this).find('.plus').hide();
    $(this).find('.minus').show();
  }
  else{
    $(this).parent().removeClass('hide-button');
    $(this).parent().addClass('show-button');
    $(this).find('.minus').hide();
    $(this).find('.plus').show();
  }
});

//Yottie window resize function (fixes displaying bug)
$('.product-tabs li.videos').on('click', function(){
  setTimeout(function() {
    //$(window).trigger('resize'); //<--- does not work entirely for some reason
    window.dispatchEvent(new Event('resize')); 
  });
});
 
/*----------------------------------------------------------
jQuery ajaxStop Functions
------------------------------------------------------------*/
$(document).ajaxComplete(function(){
  //Hide filter sections
  $('dl.narrow-by-list dd').siblings('dd').each(function(){
    if ($('ol.swatch-list', this).children('li').length == 0){
      $(this).hide();
      $(this).prev().hide();
    } else {
      $(this).show();
      $(this).prev().show();
    }
  });
  
  //Remove Wishlist from Ajax events, like quickview
  $('.wishlist').remove();
  
  //Remove Checkout button from cart view
  $('.cart-container a.checkout-cart').remove();

  
});

/*----------------------------------------------------------
jQuery Document Ready Functions
------------------------------------------------------------*/
$(document).ready(function(){
  //Apply .groups css class to mega menu items without sub menus
  $('.top-navigation li.level0').not('.m-dropdown').find('li.level1').not('.groups').addClass('groups');
  
  //Flip 'banner-sub-top' and text link if empty sub menus
  if($('.banner-sub-top').closest('li.level1').not(':has(li.level2)')){
    $('.banner-sub-top').parent('a').next().append($('.banner-sub-top').parent('a'));
  }
  
  //Remove Wishlist
  $('.wishlist').remove();

  

  $('input[name="updates[]"]').change(function() {
    $('.update-cart-button').addClass('update-cart-enable').prop('disabled', false);
  });

  $('.reduced.items, .increase.items').click(function() {
    $('.update-cart-button').addClass('update-cart-enable').prop('disabled', false);
  });
});

